import { Formik, Form, ErrorMessage, Field } from 'formik';
import {
  Backdrop,
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
} from '@mui/material';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import {
  getStudentById,
  updateStudentData,
  uploadImage,
} from '../../features/student/studentSlice';
import { getClasses } from '../../features/classes/ClassSlice';
import Modal from '@mui/material/Modal';
import { getLabelsByInstituteType } from '../../utils/constants';
import { useEffect, useState } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import ReactDatePicker from '../UIElements/ReactDatePicker';
import CloseIcon from '@mui/icons-material/Close';
const EditStudent = ({
  setEditStudent,
  StudentId,
  refreshStudents,
  setEditModal,
}) => {
  const [studentData, setStudnetData] = useState('');
  const [successModal, setSuccessModal] = useState(false);
  const [identifier, setIdentifier] = useState(studentData?.studentPhoto);
  const [classDetails, setClassDetails] = useState([]);
  const [currentDepartment, setCurrentDepartment] = useState({});
  const [currentClasses, setCurrentClass] = useState([]);
  const [currentSections, setCurrentSections] = useState([]);

  const dispatch = useDispatch();
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  let { Department, Class, Section } = getLabelsByInstituteType(instituteType);
  function guessMimeType(b64) {
    if (b64.startsWith('/9j/')) return 'image/jpeg';
    if (b64.startsWith('iVBORw0KGgo')) return 'image/png';
    return 'image/jpeg';
  }
  const IImg = () => (
    <div className=' flex justify-center items-center  size-full '>
      <div className=' flex justify-center   '>
        <PersonIcon className=' animate-pulse size-1/2 text-gray-300  ' />
      </div>
    </div>
  );

  function convertNumberToWords(number) {
    const ones = [
      '',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
      'thirteen',
      'fourteen',
      'fifteen',
      'sixteen',
      'seventeen',
      'eighteen',
      'nineteen',
    ];
    const tens = [
      '',
      '',
      'twenty',
      'thirty',
      'forty',
      'fifty',
      'sixty',
      'seventy',
      'eighty',
      'ninety',
    ];

    if (number === 0) return 'zero';
    if (number > 10000000)
      return '⚠️ Number too large. Maximum allowed is 8 digits.';
    function numToWords(n, suffix) {
      let str = '';
      if (n > 19) {
        str += tens[Math.floor(n / 10)] + (n % 10 ? '-' + ones[n % 10] : '');
      } else if (n > 0) {
        str += ones[n];
      }
      if (n !== 0) str += ' ' + suffix + ' ';
      return str;
    }

    let output = '';
    output += numToWords(Math.floor(number / 10000000), 'crore');
    output += numToWords(Math.floor((number / 100000) % 100), 'lakh');
    output += numToWords(Math.floor((number / 1000) % 100), 'thousand');
    output += numToWords(Math.floor((number / 100) % 10), 'hundred');

    if (number > 100 && number % 100 !== 0) {
      output += 'and ';
    }

    output += numToWords(number % 100, '');

    return output.trim().charAt(0).toUpperCase() + output.slice(1) + ' Rupees';
  }

  useEffect(() => {
    try {
      (async () => {
        let data = await dispatch(getStudentById(StudentId)).unwrap();

        if (data?.studentPhoto) {
          const mimeType = guessMimeType(data?.studentPhoto);
          data.studentPhoto = `data:${mimeType};base64,${data?.studentPhoto}`;
        }
        setStudnetData(data);
        const resp = await dispatch(getClasses()).unwrap();
        const list = Array.isArray(resp) ? resp : [];
        setClassDetails(list);
        const classes = list?.find(
          (obj) => obj.department === data.departmentName,
        )?.classes;
        setCurrentClass(classes);
        const sections = classes?.find(
          (obj) => obj.className === data.className,
        )?.sections;
        setCurrentSections(sections);
      })();
    } catch (error) {
      console.log(error);
    }
  }, []);
  return (
    <>
      <div className='w-full  relative'>
        {!studentData && (
          <Backdrop
            open
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: (theme) => theme.zIndex.drawer + 1,
              width: '100%',
              height: '100%',
            }}
            className='bg-white'
          >
            <div>
              <div className='text-center'>
                <CircularProgress color='primary' />
              </div>
              <br />
              <div className='text-center '>
                Fetching Details.. of {StudentId}{' '}
              </div>
            </div>
          </Backdrop>
        )}
        <Formik
          initialValues={studentData}
          validateOnChange={true}
          validationSchema={Yup.object({
            studentId: Yup.string()
              .required('Enter Id')
              .matches(/^[A-Za-z0-9]+$/, 'Only alphanumeric characters'),
            studentRollNumber: Yup.number()
              .required('Enter Roll No')
              .min(1, 'Starts from 1'),
            firstName: Yup.string()
              .transform((value) =>
                typeof value === 'string' ? value.trim() : '',
              )
              .required('Enter First Name ')
              .matches(
                /^[A-Za-z\s]+$/,
                'First name must contain only alphabets',
              )
              .min(2, 'First name must be at least 2 characters')
              .max(50, 'First name must be less than 50 characters'),

            lastName: Yup.string()
              .required('Enter Last Name ')
              .matches(/^[A-Za-z\s]+$/, 'Last name must contain only alphabets')
              .min(2, 'Last name must be at least 2 characters')
              .max(50, 'Last name must be less than 50 characters'),
            dateOfBirth: Yup.date()
              .required('Enter Date Of Birth')
              .max(new Date(), 'Date of birth cannot be in the future'),
            mobileNumber: Yup.string()
              .matches(
                /^[6-9]\d{9}$/,
                'Enter a valid 10-digit Indian mobile number',
              )
              .required('Guardian  Number is required'),
            gender: Yup.string().required('Select Gender'),
            //studentPhoto: Yup.mixed().required(' upload photo'),
            guardian: Yup.object().shape({
              name: Yup.string()
                .required('Guardian Name is required')
                .matches(/^[A-Za-z\s]+$/, ' name must contain only alphabets')
                .min(2, ' name must be at least 2 characters')
                .max(50, ' name must be less than 50 characters'),
              relation: Yup.string().required('Guardian Relation is required'),
              contactNumber: Yup.string()
                .matches(
                  /^[6-9]\d{9}$/,
                  'Enter a valid 10-digit Indian mobile number',
                )
                .required('Guardian  Number is required'),
            }),
            communicationAddress: Yup.string().transform((value) =>
              value ? value.trim() : '',
            ),
            departmentName: Yup.string().required('Select Department'),
            className: Yup.string().required(`select ${Class}`),
            // sectionName: Yup.string().required(`select ${Section}`
            // ),
            totalFees: Yup.number()
              .required('Enter Fee')
              .min(1, ' Fee must be Positive')
              .max(10000000, 'must be below 1 Crore'),
            dateOfJoining: Yup.date().required('Enter Date Of Joining'),
            dateOfLeaving: Yup.date()
              .nullable()
              .min(
                Yup.ref('dateOfJoining'),
                'Date of leaving cannot be before the date of joining',
              )
              .when('status', {
                is: (val) => val === 'INACTIVE' || val === 'DELETED',
                then: (schema) =>
                  schema.required(
                    "Date of Leaving is mandatory in case of 'InActive' or 'Delete' status",
                  ),
              }),
            status: Yup.string().required('Select Status'),
            remarks: Yup.string()
              .nullable()
              .max(100, 'Maximun 100 characters only allowed'),
          })}
          enableReinitialize={true}
          onSubmit={async (values) => {
            console.log(values);
            values = Object.fromEntries(
              Object.entries(values).map(([key, value]) => [
                key,
                typeof value === 'string' ? value.trim() : value,
              ]),
            );
            values = { ...values, studentPhoto: identifier };
            const status = await dispatch(
              updateStudentData({ ...values, studentPhoto: identifier }),
            ).unwrap();

            if (status === 200) {
              refreshStudents();
              setSuccessModal(true);
              setTimeout(() => {
                setEditModal(false);
                setEditStudent(false);
              }, 1400);
            } else {
              alert('something went wrong Try Again Later !');
            }
          }}
        >
          {({
            setFieldError,
            setFieldValue,
            setFieldTouched,
            values,
            errors,
          }) => (
            <>
              <div className='flex flex-col mx-auto '>
                <Form className='mb-4'>
                  <Tooltip
                    title='Close'
                    className='min-[800px]:hidden ml-auto block'
                  >
                    <IconButton
                      onClick={() => setEditStudent(false)}
                      className='size-fit'
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                  <div className='flex items-center justify-between gap-4 mt-0 mb-4 flex-wrap'>
                    <div>
                      <span className='text-2xl text-blue-500'>
                        Student Details <span>({StudentId})</span>
                      </span>
                    </div>
                    <div className='flex  justify-between items-center gap-4 min-w-80  '>
                      <div className='min-w-60 sm:min-w-80 mr-2 flex gap-2 items-center max-sm:flex-wrap'>
                        <label
                          htmlFor='status'
                          className='text-2xl text-blue-600'
                        >
                          Status
                        </label>
                        <div className='w-full'>
                          <Field
                            name='status'
                            as='select'
                            id='status'
                            className='formik-input w-full mt-0'
                          >
                            <option value='ACTIVE'>Active</option>
                            <option value='INACTIVE'>InActive</option>
                            <option value='DELETED'>Delete</option>
                          </Field>

                          <ErrorMessage
                            name='status'
                            component='div'
                            className='text-red-600 text-sm mt-1'
                          />
                        </div>
                      </div>
                      <Tooltip title='Close' className='max-[800px]:hidden'>
                        <IconButton
                          onClick={() => setEditStudent(false)}
                          className='size-fit'
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                  {/* Studnet Details with StudentPhoto */}
                  <div className='flex flex-col md:flex-row  gap-3'>
                    <div className=' md:w-2/3 flex flex-col  '>
                      <div className=' flex flex-col md:flex-row gap-x-3 '>
                        <div className='mb-3 md:w-1/2'>
                          <label htmlFor='studentId' className=' text-sm'>
                            Student ID
                            <span className=' text-lg text-red-800 '>*</span>
                          </label>
                          <Field
                            type='text'
                            id='studentId'
                            name='studentId'
                            placeholder='STU0000'
                            className=' formik-input '
                            readOnly
                          />
                          <ErrorMessage
                            name='studentId'
                            component='div'
                            className='text-red-600 text-sm mt-1'
                          />
                        </div>
                        <div className='mb-3 md:w-1/2'>
                          <label
                            htmlFor='studentRollNumber'
                            className=' text-sm'
                          >
                            Student Roll No
                            <span className=' text-lg text-red-800 '>*</span>
                          </label>
                          <Field
                            type='number'
                            id='studentRollNumber'
                            name='studentRollNumber'
                            placeholder=''
                            className='formik-input '
                          />
                          <ErrorMessage
                            name='studentRollNumber'
                            component='div'
                            className='text-red-600 text-sm mt-1'
                          />
                        </div>
                      </div>

                      <div className='flex flex-col md:flex-row gap-x-3'>
                        <div className='mb-3  md:w-1/2'>
                          <label htmlFor='firstName' className=' text-sm  '>
                            First Name
                            <span className=' text-lg text-red-800 '>*</span>
                          </label>
                          <Field
                            type='text'
                            id='firstName'
                            name='firstName'
                            placeholder='Enter Last Name'
                            className='formik-input '
                          />
                          <ErrorMessage
                            name='firstName'
                            component='div'
                            className='text-red-600 text-sm mt-1'
                          />
                        </div>
                        <div className='mb-3  md:w-1/2'>
                          <label htmlFor='lastName' className=' text-sm  '>
                            Last Name
                            <span className=' text-lg text-red-800 '>*</span>
                          </label>
                          <Field
                            type='text'
                            id='lastName'
                            name='lastName'
                            placeholder='Enter Last Name'
                            className='formik-input '
                          />
                          <ErrorMessage
                            name='lastName'
                            component='div'
                            className='text-red-600 text-sm mt-1'
                          />
                        </div>
                      </div>

                      <div className='flex flex-col md:flex-row gap-x-3'>
                        <div className='mb-3  md:w-1/2'>
                          <label htmlFor='dateOfBirth' className=' text-sm  '>
                            Date Of Birth
                            <span className=' text-lg text-red-800 '>*</span>
                          </label>
                          <Field
                            name='dateOfBirth'
                            className=' formik-input  mt-1'
                            component={ReactDatePicker}
                          />
                          <ErrorMessage
                            name='dateOfBirth'
                            component='div'
                            className='text-red-600 text-sm mt-1'
                          />
                        </div>
                        <div className='mb-3  md:w-1/2  '>
                          <label htmlFor='gender' className='text-sm '>
                            Gender{' '}
                            <span className=' text-lg text-red-800 '>*</span>
                          </label>
                          <Field
                            as='select'
                            id='gender'
                            name='gender'
                            className='formik-input w-full '
                          >
                            <option value=''>Select</option>
                            <option value='Male'>Male</option>
                            <option value='Female'>Female</option>
                            <option value='Others'>Others</option>
                          </Field>
                          <ErrorMessage
                            name='gender'
                            component='div'
                            className='text-red-600 text-sm '
                          />
                        </div>
                      </div>
                    </div>
                    {/* Upload Photo */}
                    <div className='md:w-1/3 flex flex-col'>
                      <label className=' text-sm'> Photo </label>

                      <div className='rounded border-[1.5px] border-indigo-100 size-full my-3'>
                        <>
                          <Field name='studentPhoto'>
                            {() => (
                              <>
                                <input
                                  type='file'
                                  id='studentPhoto'
                                  accept='image/*'
                                  onChange={async (event) => {
                                    const file = event.currentTarget.files?.[0];
                                    setFieldTouched(
                                      'studentPhoto',
                                      true,
                                      false,
                                    );
                                    if (file) {
                                      const allowedTypes = [
                                        'image/jpeg',
                                        'image/png',
                                        'image/jpg',
                                      ];
                                      const maxSize = 1 * 1024 * 1024;
                                      if (!allowedTypes.includes(file.type)) {
                                        setFieldError(
                                          'studentPhoto',
                                          'Only JPG and PNG files are allowed',
                                        );
                                        return;
                                      }
                                      if (file.size > maxSize) {
                                        setFieldError(
                                          'studentPhoto',
                                          'File too large (max 1MB)',
                                        );
                                        return;
                                      }
                                      const response = await dispatch(
                                        uploadImage(file),
                                      ).unwrap();
                                      if (response) {
                                        setFieldValue('studentPhoto', file);
                                        setIdentifier(response);
                                      }
                                    }
                                  }}
                                  className=' hidden '
                                />
                                {/* If No student Photo this code */}
                                {studentData === '' ? ( //First consdition check Before Data presents brother
                                  <IImg />
                                ) : !values?.studentPhoto ? ( //Second condition check
                                  <div className='flex items-center justify-center size-full  my-auto '>
                                    <label htmlFor='studentPhoto'>
                                      <div className='flex flex-row items-center  justify-center   '>
                                        <img
                                          src='/upload.jpg'
                                          alt=''
                                          className=' w-1/2'
                                        />
                                        <p className='block'>
                                          <span className='text-center text-red-400'>
                                            {' '}
                                            No Photo{' '}
                                          </span>
                                          <br />
                                          <span className='text-blue-600 text-xl   cursor-pointer hover:underline'>
                                            Click
                                          </span>{' '}
                                          to Upload <br />
                                        </p>
                                      </div>
                                    </label>
                                  </div>
                                ) : (
                                  //Third condition check
                                  <div className='flex  items-center  justify-evenly   size-full'>
                                    <div className='h-52  w-3/5 flex items-center justify-center  '>
                                      <img
                                        src={
                                          typeof values?.studentPhoto !==
                                          'string'
                                            ? URL.createObjectURL(
                                                values?.studentPhoto,
                                              )
                                            : values?.studentPhoto
                                        }
                                        alt='Upload Photo'
                                        className=' min-h-[70%]  max-h-[80%] object-contain rounded-md  aspect-square'
                                      />
                                    </div>
                                    <label htmlFor='studentPhoto'>
                                      <div className='flex flex-col'>
                                        <p className='p-1 bg-blue-400 rounded-md font-semibold text-white hover:bg-blue-600'>
                                          Update
                                        </p>
                                      </div>
                                    </label>
                                  </div>
                                )}
                              </>
                            )}
                          </Field>
                        </>
                      </div>
                      <div className='text-transparent'>
                        {errors.dateOfBirth || errors.gender}
                      </div>
                      <ErrorMessage
                        name='studentPhoto'
                        component='div'
                        className='text-red-600 text-sm  '
                      />
                    </div>
                  </div>
                  {/* Communication Address */}
                  <div className='grid grid-cols-1 md:grid-cols-3  gap-3 items-start'>
                    <div>
                      <label htmlFor='mobileNumber' className=' text-sm  '>
                        Mobile Number
                        <span className=' text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        type='text'
                        id='mobileNumber'
                        name='mobileNumber'
                        placeholder='XXX-XXX-XXXX'
                        className='formik-input '
                      />
                      <ErrorMessage
                        name='mobileNumber'
                        component='div'
                        className='text-red-600 text-sm mt-1'
                      />
                    </div>
                    <div className='col-span-2'>
                      <label
                        htmlFor='communicationAddress'
                        className=' text-sm'
                      >
                        Communication Address
                        <span className=' text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        type='text'
                        id='communicationAddress'
                        name='communicationAddress'
                        placeholder='Enter Communicaiton Address'
                        className='formik-input '
                      />
                      <ErrorMessage
                        name='communicationAddress'
                        component='div'
                        className='text-red-600 text-sm mt-1'
                      />
                    </div>
                  </div>
                  {/* Graduation Details */}
                  <div className='grid grid-cols-1 md:grid-cols-3  gap-3 '>
                    <div className='w-full  '>
                      <label htmlFor='guardian.relation' className='text-sm'>
                        Guardian Relation{' '}
                        <span className=' text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        as='select'
                        id='guardian.relation'
                        name='guardian.relation'
                        className='formik-input  '
                      >
                        <option value=''>Select</option>
                        <option value='Father'>Father</option>
                        <option value='Mother'>Mother</option>
                        <option value='Others'>Others</option>
                      </Field>
                      <ErrorMessage
                        name='guardian.relation'
                        component='div'
                        className='text-red-600 text-sm '
                      />
                    </div>
                    <div className='w-full  '>
                      <label htmlFor='guardian.name' className=' text-sm  '>
                        Name
                        <span className=' text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        type='text'
                        id='guardian.name'
                        name='guardian.name'
                        placeholder='Enter Guardian Name'
                        className='formik-input '
                      />
                      <ErrorMessage
                        name='guardian.name'
                        component='div'
                        className='text-red-600 text-sm mt-1'
                      />
                    </div>
                    <div className='w-full  '>
                      <label
                        htmlFor='guardian.contactNumber'
                        className=' text-sm'
                      >
                        Guardian Number
                        <span className=' text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        type='text'
                        id='guardian.contactNumber'
                        name='guardian.contactNumber'
                        placeholder=''
                        className='formik-input'
                      />
                      <ErrorMessage
                        name='guardian.contactNumber'
                        component='div'
                        className='text-red-600 text-sm mt-1'
                      />
                    </div>
                  </div>

                  {/* class,fee,Section */}
                  <div className=' grid grid-cols-1 md:grid-cols-3  gap-3  md:gap-y-0 items-start mb-4'>
                    {/* Department */}
                    <div className=' w-full '>
                      <label htmlFor='departmentName' className='text-sm'>
                        {Department}{' '}
                        <span className=' text-lg text-red-800 '>*</span>
                      </label>
                      <Field name='departmentName'>
                        {({ field }) => (
                          <select
                            {...field}
                            className='formik-input'
                            onChange={(e) => {
                              field.onChange(e);
                              const value = e.target.value;
                              setFieldValue('departmentName', value);
                              setFieldValue('className', '');
                              setFieldValue('sectionName', '');
                              const selectedDepartment = classDetails.find(
                                (obj) => obj.department === value,
                              );
                              setCurrentDepartment(selectedDepartment);
                              setCurrentClass(selectedDepartment?.classes);
                              setCurrentSections([]);
                            }}
                          >
                            {classDetails?.length > 0 ? (
                              <option value=''>
                                ---Select {Department}---
                              </option>
                            ) : (
                              <option value=''>
                                --- No {Department} Available ---
                              </option>
                            )}
                            {classDetails?.map((item, index) => (
                              <option key={index} value={item?.department}>
                                {item?.department}
                              </option>
                            ))}
                          </select>
                        )}
                      </Field>
                      <ErrorMessage
                        name='departmentName'
                        component='div'
                        className='text-red-600 text-sm mt-1'
                      />
                    </div>
                    {/* class */}
                    <div className=' w-full '>
                      <label htmlFor='className' className='text-sm'>
                        {Class}{' '}
                        <span className=' text-lg text-red-800 '>*</span>
                      </label>
                      <Field name='className'>
                        {({ field }) => (
                          <select
                            {...field}
                            className='formik-input'
                            onChange={(e) => {
                              field.onChange(e);
                              const value = e.target.value;
                              setFieldValue('className', value);
                              const selectedClass =
                                currentDepartment?.classes?.find(
                                  (obj) => obj.className === value,
                                );
                              setCurrentSections(selectedClass?.sections);
                            }}
                          >
                            {!values?.departmentName ? (
                              <option value=''>
                                ---First Select {Department} ---
                              </option>
                            ) : currentClasses?.length > 0 ? (
                              <option value=''>---Select {Class}----</option>
                            ) : (
                              <option value='2'>---No {Class} to Select</option>
                            )}
                            {currentClasses?.map((item, index) => (
                              <option key={index} value={item.className}>
                                {item.className}
                              </option>
                            ))}
                          </select>
                        )}
                      </Field>
                      <ErrorMessage
                        name='className'
                        component='div'
                        className='text-red-600 text-sm mt-1'
                      />
                    </div>
                    {/* section */}
                    {instituteType.toLowerCase() === 'college' && (
                      <div className=' w-full '>
                        <label htmlFor='sectionName' className='text-sm'>
                          {Section} *
                        </label>
                        <Field name='sectionName'>
                          {({ field }) => (
                            <select
                              required={
                                instituteType.toLowerCase() === 'college'
                              }
                              {...field}
                              className='formik-input'
                              onChange={(e) => {
                                field.onChange(e);
                                const value = e.target.value;
                                setFieldValue('sectionName', value);
                                // const selectedSection=currentClasses.find(obj=>obj.department===value)
                                // setCurrentClass(selectedObject.classes)
                              }}
                            >
                              {!values?.className ? (
                                <option value=''>
                                  ---First Select {Class}
                                  {''} ---
                                </option>
                              ) : currentClasses?.length > 0 ? (
                                <option value=''>
                                  ---Select {Section} ---
                                </option>
                              ) : (
                                <option value='2'>---No {Section} ---</option>
                              )}
                              {currentSections?.map((item, index) => (
                                <option key={index} value={item.section}>
                                  {item.section}
                                </option>
                              ))}
                            </select>
                          )}
                        </Field>
                        <ErrorMessage
                          name='sectionName'
                          component='div'
                          className='text-red-600 text-sm mt-1'
                        />
                      </div>
                    )}
                    {/*Total Fees, DateofJoining ,DateOfLeaving */}
                    <div className=' w-full '>
                      <label htmlFor='totalFees' className=' text-sm  '>
                        Total Fee
                        <span className=' text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        type='text'
                        inputMode='numeric'
                        pattern='[0-9]*'
                        id='totalFees'
                        name='totalFees'
                        placeholder='₹0.00'
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            '',
                          );
                        }}
                        className=' w-full border-[1.5px] border-indigo-100 rounded p-2 '
                      />
                      {values?.totalFees > 0 && !errors?.totalFees && (
                        <small className=' text-green-600 '>
                          {convertNumberToWords(values?.totalFees)}{' '}
                        </small>
                      )}
                      <ErrorMessage
                        name='totalFees'
                        component='div'
                        className='text-red-600 text-sm mt-1'
                      />
                    </div>

                    <div className='w-full '>
                      <label htmlFor='dateOfJoining' className=' text-sm'>
                        Date Of Joining
                        <span className=' text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        name='dateOfJoining'
                        className=' formik-input  mt-1'
                        component={ReactDatePicker}
                      />
                      <ErrorMessage
                        name='dateOfJoining'
                        component='div'
                        className='text-red-600 text-sm mt-1'
                      />
                    </div>

                    <div className='w-full '>
                      <label htmlFor='dateOfLeaving' className=' text-sm'>
                        Date Of Leaving
                        <span className=' text-lg text-red-800 '> </span>
                      </label>
                      <Field
                        name='dateOfLeaving'
                        className=' formik-input  mt-1'
                        component={ReactDatePicker}
                      />
                      <ErrorMessage
                        name='dateOfLeaving'
                        component='div'
                        className='text-red-600 text-sm mt-1'
                      />
                    </div>
                  </div>
                  {/* Remarks ,Buttons  */}
                  <div className=' grid grid-cols-1 md:grid-cols-3  gap-3 items-end  '>
                    <div className='col-span-2 '>
                      <label htmlFor='remarks' className=' text-sm'>
                        Remarks
                      </label>
                      <Field
                        type='text'
                        id='remarks'
                        name='remarks'
                        placeholder='Enter remarks'
                        className='formik-input '
                      />
                      <ErrorMessage
                        name='remarks'
                        component='div'
                        className='text-red-600 text-sm mt-1'
                      />
                    </div>
                    <div className=' flex items-end justify-center gap-3 ml-auto '>
                      <Button
                        size='small'
                        variant='outlined'
                        type='reset'
                        className='normal-case px-4 py-2'
                        onClick={() => {
                          setEditModal(false);
                          setEditStudent(false);
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        size='small'
                        variant='contained'
                        type='submit'
                        className='normal-case px-8 py-2'
                      >
                        Save
                      </Button>
                    </div>{' '}
                  </div>
                  {/* Cancel,Save*/}
                </Form>
              </div>
              <Modal
                open={successModal}
                onClose={() => setSuccessModal(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
              >
                <div className='bg-white fixed top-1/2 left-1/2  -translate-x-1/2 -translate-y-1/2 p-8 rounded-3xl  text-blue-700'>
                  <div className='flex justify-center items-center md:h-[150px] '>
                    <img
                      src='/images/Edit1.gif'
                      className=' object-contain m-3 h-1/2  '
                    />
                  </div>
                  <div>
                    <h5 className='text-center '>
                      Student Details updation Completed <br></br>
                    </h5>
                  </div>
                  <div>
                    <h5 className='text-center'> Successfully !</h5>{' '}
                  </div>
                </div>
              </Modal>
            </>
          )}
        </Formik>
      </div>
    </>
  );
};

export default EditStudent;
